export const buildHubspotMeetingUrl = (meetingUrl, props = {}, additionalParams = {}) => {
    if (!meetingUrl) {
        return '';
    }
    const allProps = Object.assign(Object.assign({}, props), additionalParams);
    const urlParams = [];
    Object.entries(allProps).forEach(([key, value]) => {
        if (!value)
            return;
        if (key === 'name') {
            const names = value.split(' ').filter(Boolean);
            const lastName = names.pop() || '';
            const firstName = names.join(' ');
            if (firstName)
                urlParams.push(`firstName=${encodeURIComponent(firstName)}`);
            if (lastName)
                urlParams.push(`lastName=${encodeURIComponent(lastName)}`);
        }
        else {
            urlParams.push(`${key}=${encodeURIComponent(value)}`);
        }
    });
    if (urlParams.length === 0)
        return meetingUrl;
    const separator = meetingUrl.includes('?') ? '&' : '?';
    return `${meetingUrl}${separator}${urlParams.join('&')}`;
};
